import React from 'react';
import Social from './Social';
import './Banner.css';
import { TypeAnimation } from 'react-type-animation';

const Banner = () => {
  // Scroll to the contact with smooth behavior
  const handleScroll = () => {
    const hash = '#contact';
    const el = document.querySelector(hash);
    const offsetTop = el.offsetTop;
    if (typeof window !== `undefined`) {
      window.scrollTo({
        top: offsetTop,
        left: 0,
        behavior: 'smooth',
      });
    }
  };
  return (
    <section className="home-section container mx-auto">
      <div className="home-container  grid">
        <div className="home-content grid">
          <Social />
          <div className="home-image hidden sm:block"></div>
          <div className="home-data ">
            <p className="text-primary text-[25px]">Hello, I'm</p>
            <h2
              className="text-white font-[900]
             text-[45px]"
            >
              Parvez Hasan Rubel
            </h2>
            <h3 className="text-white text-lg sm:text-[25px] ">
              <TypeAnimation
                sequence={[
                  'Software Developer',
                  2000,
                  'Javascript Lover',
                  2000,
                  'App Developer',
                  2000,
                  'GoLang Developer',
                  2000,
                  'Life time Learner',
                  2000,
                ]}
                wrapper="span"
                speed={150}
                repeat={Infinity}
                style={{ fontSize: '28px', display: 'inline-block' }}
              />
            </h3>

            <div className="flex justify-center md:justify-start gap-4 mt-4 text-white text-base  ">
              <a
                href="https://drive.google.com/uc?export=download&id=1lXcKZSC3WNBqShs_67VcqaXY7q_Fe7OS"
                className=" border-2 border-primary px-7 py-2"
              >
                Resume
              </a>
              <button
                onClick={handleScroll}
                className="border-2 border-primary px-7 py-2"
              >
                Hire Me
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
